import React from 'react';

import PlaceholderTab from '../../shared/PlaceholderTab';

import { INCLUSION_FIELDS } from './fields';

export default function InclusionsTab() {
  return <PlaceholderTab configuredFieldCount={INCLUSION_FIELDS.length} title="Inclusions" />;
}
